import { FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { IStudent, IStudentClassInfo } from '../../../models/students.model';
import useAxios from '../../../hooks/useAxios';
import { Table, TableColumnsType } from 'antd';
import Button from '../../Button';
import ErrorResponse from '../../ErrorResponse';
import Loader from '../../Loader';
import { IGetAwardHistory, IGetAwards } from '../../../models/award.model';
import { getAwardHistory, getAwards } from '../../../api/award.api';

interface IProps {
  student?: IStudent;
  classInfo?: IStudentClassInfo[];
}

const AwardsList: FC<IProps> = ({ student, classInfo }) => {
  const { t } = useTranslation();
  const { data: res, isLoading, error, execute } = useAxios<IGetAwardHistory>();
  const { data: res2, isLoading: isLoading2, error: error2, execute: execute2 } = useAxios<IGetAwards>();

  useEffect(() => {
    execute2(getAwards());
  }, []);
  
  const onChangeAwardsCode = (value: any) => {
    res2?.data.map((item: any) => {
      if(value === item.name){
        window.open(`/class/print-award?awardCode=${item.awardCode}&memberEngName=${student?.studentEngName}`, '_blank');
      }
    });    
  }

  const columns: TableColumnsType<any> = [
    {
      title: t('class.class.column65'),
      dataIndex: 'semesterName',
      key: 'semesterName',
      align: 'center',
      sorter: (a, b) => a.semesterName?.localeCompare(b.semesterName),
    },
    {
      title: t('class.class.column86'),
      dataIndex: 'courseName',
      key: 'courseName',
      align: 'center',
      sorter: (a, b) => a.courseName?.localeCompare(b.courseName),
    },
    {
      title: t('class.class.column57'),
      dataIndex: 'className',
      key: 'className',
      align: 'center',
      sorter: (a, b) => a.className?.localeCompare(b.className),
    },
    {
      title: 'Awards',
      dataIndex: 'name',
      key: 'name',
      align: 'center',
      sorter: (a, b) => a.name?.localeCompare(b.name),
    },
    {
      title: t('class.class.button15'),
      dataIndex: 'awardCode',
      key: 'awardCode',
      align: 'center',
      render: (value, record) => (
        <div className='comm-btn__area justify-content-center'>
          <Button
            className="btn-basic small mint"
            onClick={() => {
              // window.open(`/class/print-award?awardCode=${value}&memberEngName=${student?.studentEngName}`, '_blank');
              onChangeAwardsCode(record.name);
            }}
            text={t('class.class.button15')}
            disabled={!value}
          />
        </div>
      ),
    },
  ];

  useEffect(() => {
    if (student?.studentCode) {
      classInfo?.map((item: any) => {
        execute(getAwardHistory(student.studentCode, item.classCode));
      })
    }
  }, [student?.studentCode]);
  
  return (
    <>
      {isLoading || isLoading2 ? <Loader /> : null}
      <ErrorResponse error={error || error2} />
      <Table
        className='comm-table__area'
        columns={columns}
        dataSource={res?.data?.awards}
        pagination={{
          pageSize: 9999999,
        }}
      />
      
    </>
  );
};

export default AwardsList;
